import { makeStyles, Text, Accordion, AccordionItem, AccordionHeader, AccordionPanel } from "@fluentui/react-components";
import TitleText from "../../../components/titleText/TitleText";
import IPageFAQ, { IFAQItem } from "../../../models/page/pageComponents/IPageFAQ";
import { dolphinTokens } from "../../../utils/Theme";

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        padding: "0 2rem",
        maxWidth: "1200px",
        margin: "0 auto",
        justifyContent: "center",
        alignItems: "center",
        
        "@media (max-width: 768px)": {
            marginTop: "1rem",
        },
    },
    accordionContainer: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: "1rem"
    },
    accordionItem: {
        backgroundColor: "#f9f9f9",
        borderRadius: "8px",
        border: "1px solid #e0e0e0",
    },
    question: {
        fontWeight: "600",
        fontSize: "1.2rem !important",
        color: `${dolphinTokens.colorLightBlue} !important`,
        "& button": {
            fontSize: "1.2rem !important",
            fontWeight: "500",
        }
    },
    answer: {
        color: "#666666",
        fontSize: "1rem",
        lineHeight: "1.8",
        padding: "1rem 1.5rem !important",
        display: "block",
    }
});

const FAQItem = (props: { item: IFAQItem; value: string }) => {
    const styles = useStyles();

    return (
        <AccordionItem value={props.value} className={styles.accordionItem}>
            <AccordionHeader className={styles.question}>
                {props.item.question}
            </AccordionHeader>
            <AccordionPanel>
                <Text className={styles.answer}>{props.item.answer}</Text>
            </AccordionPanel>
        </AccordionItem>
    );
};

export default function FAQ(props: IPageFAQ) {
    const styles = useStyles();

    return (
        <div className={styles.container}>
            <TitleText
                title={props.title}
                titleHighlightedWords={props.titleHighlightedWords}
                subtitle={props.subtitle}
                alignment="center"
                width="100%"
                />
                
            <div className={styles.accordionContainer}>
                <Accordion collapsible>
                    {props.items.map((item, index) => (
                        <FAQItem key={index} item={item} value={`faq-${index}`} />
                    ))}
                </Accordion>
            </div>
        </div>
    );
}
